import {
  RateWms
} from './rate.wms.model';

export class RateGroupWms {
  label: string;
  rates: RateWms[] = [];
}